import { useState } from 'react';

export default () => {
  const [storeConfig, setStoreConfig] = useState<any>([]);
  return { storeConfig, setStoreConfig };
};
